import {Component} from '@angular/core';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {SearchService} from "../../services/search.service";
import {GenericSearchResults} from "../../services/dtos/generic-search-result.dto";
import {DecimalPipe, NgIf} from "@angular/common";
import {Base64ImageComponent} from "../base64-image/base64-image.component";
import {User} from "../../auth/primitives/user";
import {Components, Entity} from "../../state/entities/entity.model";
import {Store} from "@ngrx/store";
import {cameraActions} from "../../state/camera/camera.actions";
import {TextUtilsService} from "../../services/text-utils.service";
import {UsersService} from "../../services/users.service";
import {serverEntityToEntity} from "../../services/dtos/server-entity.dto";
import {SearchResultUserComponent} from "../search-result-user/search-result-user.component";
import {SearchResultEntityComponent} from "../search-result-entity/search-result-entity.component";
import {IconsService} from "../../services/icons.service";
import {Router} from "@angular/router";

@Component({
  selector: 'search-pane',
  standalone: true,
  imports: [FontAwesomeModule, NgIf, DecimalPipe, Base64ImageComponent, SearchResultUserComponent, SearchResultEntityComponent],
  templateUrl: './search-pane.component.html',
  styleUrl: './search-pane.component.scss'
})
export class SearchPaneComponent {

  searchResults: GenericSearchResults | any = {
    users: [],
    entities: []
  }

  displayedResults: GenericSearchResults | any = {
    users: [],
    entities: []
  }

  bShowAllUsers = false
  bshowAllEntities = false
  searchTerm: string

  constructor(
      private searchService: SearchService,
      private textUtilsService: TextUtilsService,
      private usersService: UsersService,
      private store: Store,
      private router: Router,
      public iconService: IconsService
  ) {
    this.searchService.searchResults.subscribe(async (results) => {
      this.searchResults = {
        users: results.users,
        entities: results.entities
      }
      this.displayedResults = {
        users: this.searchResults.users.slice(0, 3),
        entities: this.searchResults.entities.slice(0, 3)
      }
    })
    this.searchService.searchTerm.subscribe((term) => {
      this.searchTerm = term
    })
  }

  close() {
    this.router.navigate([{outlets: {'right-pane': null }}]);
  }

  onClose() {
    this.searchService.clearSearch()
  }

  showAllUsers(show: boolean) {
    this.bShowAllUsers = show
    if (show) {
      this.displayedResults.users = this.searchResults.users
    } else {
      this.displayedResults.users = this.searchResults.users.slice(0, 3)
    }
  }
  showAllEntities(show: boolean) {
    this.bshowAllEntities = show
    if (show) {
      this.displayedResults.entities = this.searchResults.entities
    } else {
      this.displayedResults.entities = this.searchResults.entities.slice(0, 3)
    }
  }


}
